'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var aliases = {
  fade: ['clearer'],
  grayscale: ['greyscale']
};

exports.default = aliases;